
// プログレス

// プログレス制御
import CaracolLoadProgress from '../caracol_es2015.1.0/util/progress';
// スクロール in ビュー
import CaracolScrollInView from '../caracol_es2015.1.0/effect/scroll_in_view';


export default function () {

    // プログレスバーエレメント
    const $progress_bar = $('.c-fadein .c-fadein__progress');

    // プログレスバー設定
    const progress = new CaracolLoadProgress({
        onProgress: (total, count, percent) => {
            // 読み込み中：バーエレメントの幅調整
            $progress_bar.css({ width: `${percent * 100}%` });
        },
        onComplete: (total, count) => {
            // 読み込み完了：幅100%
            $progress_bar.css({ width: '100%' });

            // 読み込み完了通知
            $(window).trigger('load_complete');

            // フェードイン
            setTimeout(() => {
                $('.c-fadein').addClass('c-fadein_start');
            }, 300);
            setTimeout(() => {
                $('.c-fadein').remove();
                // in ビュー
                const inView = new CaracolScrollInView('.p-iv', {
                    class: { in: 'p-iv_in' }
                });
                inView.start();

                // フェードイン完了通知
                $(window).trigger('fadein_complete');

            }, 1300);


        }
    });
    progress.start();
}



// WEBPACK FOOTER //
// ./js/module/progress.js